import { ProductKey } from "@/components/signup/utils";
import { useUserContext } from "@/components/user-context";

import { CompassSignup } from "../compass/compass-signup";
import { ConfluenceSignup } from "../confluence/confluence-signup";
import { DevAiSignup } from "../dev-ai/dev-ai-signup";
import { JiraSignup } from "../jira/jira-signup";
import { JpdSignup } from "../jira-product-discovery/jpd-signup";
import { JsmSignup } from "../jira-service-management/jsm-signup";
import { LoomSignup } from "../loom/loom-signup";
import { ServiceCollectionSignup } from "../service-collection/service-collection-signup";
import { StatuspageSignup } from "../statuspage/statuspage-signup";
import { TeamworkCollectionSignup } from "../teamwork-collection/teamwork-collection-signup";

const PRODUCT_MAPPINGS = {
    [ProductKey.JIRA_SOFTWARE]: JiraSignup,
    [ProductKey.JIRA_SERVICE_MANAGEMENT]: JsmSignup,
    [ProductKey.JIRA_PRODUCT_DISCOVERY]: JpdSignup,
    [ProductKey.DEVAI]: DevAiSignup,
    [ProductKey.COMPASS]: CompassSignup,
    [ProductKey.CONFLUENCE]: ConfluenceSignup,
    [ProductKey.LOOM]: LoomSignup,
    [ProductKey.SERVICE_COLLECTION]: ServiceCollectionSignup,
    [ProductKey.STATUSPAGE]: StatuspageSignup,
    [ProductKey.TEAMWORK_COLLECTION]: TeamworkCollectionSignup
};

export const useProductSignupComponent = () => {
    const { product } = useUserContext();

    if (product && product.key in PRODUCT_MAPPINGS) {
        return PRODUCT_MAPPINGS[product.key as keyof typeof PRODUCT_MAPPINGS];
    }

    return null;
};
